import { indexItems } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">
            热门专题
          </h2>
          <p className="text-sm text-foreground-500">精选全网最热八卦专题，一站式吃瓜导航</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item, i) => (
            <a
              key={i}
              href="#topics"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('topics')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group bg-background-50 rounded-xl p-5 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-start gap-3 mb-3">
                <span className={`w-10 h-10 flex items-center justify-center ${item.color} rounded-lg shrink-0`}>
                  <i className={`${item.icon} text-white text-lg`}></i>
                </span>
                <span className={`px-2 py-0.5 rounded-full text-[10px] font-bold text-white ${item.tag === 'NEW' ? 'bg-accent-500' : item.tag === '热' ? 'bg-primary-500' : 'bg-primary-500'}`}>
                  {item.tag}
                </span>
              </div>
              <h3 className="font-heading text-base text-foreground-950 mb-1 group-hover:text-primary-600 transition-colors">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 mb-2">{item.subtitle}</p>
              <p className="text-xs text-foreground-400 leading-relaxed line-clamp-2">{item.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}